import { flow, makeObservable, observable } from 'mobx';
import { ApiResponse } from '@roc/client-portal-shared/services';
import { GlobalStore, FormStore } from '@roc/feature-app-core';
import { RegisterService } from '../services/registerService';

const form = {
  fields: {
    firstName: {
      value: '',
      error: null,
      rule: 'required',
    },
    lastName: {
      value: '',
      error: null,
      rule: 'required',
    },
    email: {
      value: '',
      error: null,
      rule: 'required|email',
    },
    phoneNumber: {
      value: '',
      error: null,
      rule: 'required|regex:/^\\d{3}-?\\d{3}-?\\d{4}$/|alpha_dash',
      message: 'Phone must be a number with the format xxx-xxx-xxxx',
    },
    company: {
      value: '',
      error: null,
      rule: 'required',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class RegisterStore extends FormStore {
  private globalStore: GlobalStore;
  private registerService: RegisterService;
  isRegistrationEnabled: boolean;

  constructor(globalStore) {
    super({ ...form }, globalStore);
    this.globalStore = globalStore;
    this.registerService = new RegisterService();
    makeObservable(this, {
      isRegistrationEnabled: observable,
      getRegistrationEnabled: flow,
    });
  }

  *getRegistrationEnabled() {
    try {
      const response: ApiResponse = yield this.registerService.getRegistrationEnabled();
      this.isRegistrationEnabled = response?.data?.data;
    }
    catch (error) {
      console.log(error);
    }
  }
}

export default RegisterStore;
